import React, { Component } from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import { AppLayout } from './static/Layouts';
import Auth from './Auth';
import Jobs from './Jobs';
import createLogger from '../utils/createLogger';

const DEBUG = false;
const debug = createLogger(DEBUG, `App.js`);

class App extends React.Component {

  /* ------------ lifecycle methods ------------ */
  constructor(props) {
    super(props);
    debug.enter(`constructor`);
  }

  componentDidUpdate(prevProps,
                     prevState) {
    debug.enter(`componentDidUpdate`);
  }

  componentDidMount() {
    debug.enter(`componentDidMount`);
  }

  componentWillUnmount() {
    debug.enter(`componentWillUnmount`);
  }

  /* ------------ navigation ------------ */
  rootRedirect = () => {
    const { isAuthenticated } = this.props;
    return isAuthenticated
      ? <Redirect to="/jobs"/>
      : <Redirect to="/auth"/>
  };

  /* ------------ render methods ------------ */
  render() {
    const { rootRedirect } = this;

    debug.enter(`render`);

    return (
      <AppLayout>
        <Switch>
          <Route exact path="/" render={rootRedirect}/>
          <Route path="/callback" component={Auth}/>
          <Route path="/auth" component={Auth}/>
          <Route path="/jobs" component={Jobs}/>
        </Switch>
      </AppLayout>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/components/App.js